import { useTranslation } from 'react-i18next';
import { formatDate, formatLastActive } from '@/utils/dateUtils';

interface LastOnlineCellProps {
  lastOnlineAt?: string;
}

/** Displays time-ago text for the last online date. On hover, a popout shows the exact date. */
export function LastOnlineCell({ lastOnlineAt }: LastOnlineCellProps) {
  const { t } = useTranslation();

  if (!lastOnlineAt) {
    return (
      <td className="size-px whitespace-nowrap px-4 py-1">
        <span className="text-sm text-onsurface">-</span>
      </td>
    );
  }

  const timeAgoLabel = formatLastActive(lastOnlineAt, t);
  const exactDate = formatDate(lastOnlineAt);

  return (
    <td className="size-px whitespace-nowrap px-4 py-1">
      <div className="relative inline-block group">
        <span className="text-sm text-onsurface cursor-default">{timeAgoLabel}</span>

        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2 py-1 rounded-md bg-surface-darker border border-border shadow-md text-xs text-onsurface whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-150 z-10">
          {exactDate}
        </div>
      </div>
    </td>
  );
}
